import { INativeServiceSyncable } from "./native-service-syncable";
import { Metadata } from "./metadata";
import { IReplicableEntity } from "./replicable-entity";

export class CashTransaction {
    id?: string;
    cashRegister!: string;
    transactionType!: CashTransactionType;
    amount!: number;
    recordedBy!: string;
    recordedDate!: Date;
    note?: string;
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
}

export enum CashTransactionType {
    CashIn = 1,
    CashOut = 2
}

export class CashInCashRegister implements IReplicableEntity {
    id?: string;
    cashRegisterId?: string;
    amount!: number;
    recordedBy!: string;
    recordedDate!: Date;
    note?: string;
    cashRegister!: string;
    transactionType!: CashTransactionType;
    /** @deprecated Use metadata.syncInfo instead. Kept for backward compatibility with Native Service. */
    syncMetadata?: INativeServiceSyncable;
    metadata?: Metadata;
}

export class CashOutCashRegister implements IReplicableEntity {
    id?: string;
    cashRegisterId?: string;
    amount!: number;
    recordedBy!: string;
    recordedDate!: Date;
    note?: string;
    cashRegister!: string;
    transactionType!: CashTransactionType;
    /** @deprecated Use metadata.syncInfo instead. Kept for backward compatibility with Native Service. */
    syncMetadata?: INativeServiceSyncable;
    metadata?: Metadata;
}

export class CashTransactionLog {
    amount!: number;
    note?: string;
    transactionType!: CashTransactionType;
    recordedBy!: string;
    recordedDate!: Date;
    syncMetadata?: INativeServiceSyncable;
}